// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


import AutocompleteController from "./autocomplete_controller.js"
application.register("autocomplete", AutocompleteController)

import BootstrapController from "./bootstrap_controller.js"
application.register("bootstrap", BootstrapController)

import ConditionalFormsController from "./conditional_forms_controller.js"
application.register("conditional_forms", ConditionalFormsController)

import GeocoordinatesController from "./geocoordinates_controller.js"
application.register("geocoordinates", GeocoordinatesController)

import GmapController from "./gmap_controller.js"
application.register("gmap", GmapController)

import MillsController from "./mills_controller.js"
application.register("mills", MillsController)

import MultiFieldsController from "./multi_fields_controller.js"
application.register("multi_fields", MultiFieldsController)

import NestedAttributesController from "./nested_attributes_controller.js"
application.register("nested_attributes", NestedAttributesController)

import TimeoutController from "./timeout_controller"
application.register("timeout", TimeoutController)

import TinymceController from "./tinymce_controller.js"
application.register("tinymce", TinymceController)

